module.exports = __webpack_public_path__ + "static/img-hands.f8ecd90a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-hands.jpg
// module id = 785
// module chunks = 218122631423814